/**
 * Auth Utilities - PocketBase version
 */
import pb from '../pocketbase';

// PocketBase storage key
const PB_AUTH_KEY = 'pocketbase_auth';

// Быстрая проверка, есть ли активная сессия
export const hasActiveSession = () => {
  return pb.authStore.isValid;
};

// Получение текущей сессии (для совместимости)
export const getCurrentSession = () => {
  if (!pb.authStore.isValid) return null;

  return {
    access_token: pb.authStore.token,
    user: pb.authStore.model,
    expires_at: null // PocketBase handles expiration internally
  };
};

// Проверка, истекла ли сессия
export const isSessionExpired = (session) => {
  // PocketBase authStore.isValid handles this
  return !pb.authStore.isValid;
};

// Получение текущего пользователя
export const getCurrentUser = () => {
  return pb.authStore.model;
};

// Dev-only autologin helper
export const maybeDevAutoLogin = async () => {
  try {
    const isDev = process.env.NODE_ENV === 'development';
    const email = process.env.REACT_APP_DEV_EMAIL;
    const password = process.env.REACT_APP_DEV_PASSWORD;
    const host = window.location.hostname;
    const isProdHost = host === 'app.sense-games.ru';

    if (!isDev || !email || !password || isProdHost) return false;
    if (sessionStorage.getItem('dev.autologin.tried') === '1') return false;
    if (localStorage.getItem('dev.autologin.disable') === '1') return false;

    sessionStorage.setItem('dev.autologin.tried', '1');

    await pb.collection('users').authWithPassword(email, password);
    return true;
  } catch (e) {
    console.warn('Dev autologin error:', e);
    return false;
  }
};

// Выход из аккаунта
export const signOut = () => {
  pb.authStore.clear();
};

// Вход по email/password
export const signInWithPassword = async (email, password) => {
  try {
    const authData = await pb.collection('users').authWithPassword(email, password);
    return { data: authData, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

// OAuth авторизация
export const signInWithOAuth = async (provider) => {
  try {
    const authData = await pb.collection('users').authWithOAuth2({ provider });
    return { data: authData, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export default {
  hasActiveSession,
  getCurrentSession,
  isSessionExpired,
  getCurrentUser,
  maybeDevAutoLogin,
  signOut,
  signInWithPassword,
  signInWithOAuth,
};
